import { Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AssistantType, GoalApiService, GoalInterface, GoalType } from '@vendasta/ai-assistants';
import { GalaxyColumnDef, GalaxyDataSource, GalaxyTableModule, Row } from '@vendasta/galaxy/table';
import { ACCOUNT_GROUP_ID_TOKEN, PARTNER_ID_TOKEN } from '../../../core/tokens';
import { AiCapabilityTableDataSource } from './ai-capabilities-table.data-source';

@Component({
  selector: 'ai-capabilities-table',
  standalone: true,
  imports: [GalaxyTableModule, MatTableModule, MatIconModule],
  templateUrl: './ai-capabilities-table.component.html',
  styleUrl: './ai-capabilities-table.component.scss',
})
export class AiCapabilitiesTableComponent {
  accountGroupId$ = inject(ACCOUNT_GROUP_ID_TOKEN);
  partnerId$ = inject(PARTNER_ID_TOKEN);
  goalApiService = inject(GoalApiService);

  assistantType = input.required<AssistantType>();
  excludedGoalIds = input<string[]>([]);
  selectedGoals = output<GoalInterface[]>();

  dataSource = computed(
    () =>
      new AiCapabilityTableDataSource(this.goalApiService, this.assistantType(), this.accountGroupId$, this.partnerId$),
  );
  tableDataSource = computed(() => new GalaxyDataSource<GoalInterface, unknown, unknown>(this.dataSource()));

  columns: GalaxyColumnDef[] = [
    {
      id: 'icon',
      title: '',
    },
    {
      id: 'name',
      title: 'Name',
    },
    {
      id: 'description',
      title: 'Description',
    },
  ];

  selectionChanged(selected: Row[]) {
    this.selectedGoals.emit(selected);
  }

  isRowDisabled(row: GoalInterface): boolean {
    const id = row?.id ?? '';
    const excluded = this.excludedGoalIds();
    const isInExcluded = !!id && excluded.includes(id);
    const isOverrideOfExcluded = row?.overrideOf?.id && excluded.includes(row.overrideOf.id);
    const isPersonality = row?.type === GoalType.GOAL_TYPE_PERSONALITY;
    return isInExcluded || isOverrideOfExcluded || isPersonality;
  }
}
